export default "__VITE_ASSET__Dxo1OdZk__"